module.exports = __webpack_public_path__ + "img/img.110e6082.png";